export default "__VITE_ASSET__BD2cbxjg__"